/**
 * Constantes para el módulo de recogidas
 *
 * Estados según integración con MSoft:
 * - SOLICITADA: Creada en BD local, pendiente confirmación MSoft
 * - CONFIRMADA: MSoft confirmó la recogida (codError = 0)
 * - ERROR: MSoft rechazó la recogida (codError ≠ 0)
 *
 * Ciclo de ejecución, que llega al sincronizar el seguimiento con MSoft:
 * - ASIGNADA: asignada a transportista
 * - EN_CURSO: el transportista está realizándola
 * - REALIZADA: completada
 * - ANULADA: la anula MSoft, a menudo por una incidencia
 *
 * Estados terminales que decidimos nosotros, no MSoft:
 * - CANCELADA: se cancela desde la aplicación
 * - RECEPCIONADA: la mercancía ha llegado al almacén
 */

export const RECOGIDA_ESTADO = {
    SOLICITADA: 'SOLICITADA',
    CONFIRMADA: 'CONFIRMADA',
    ERROR: 'ERROR',
    ASIGNADA: 'ASIGNADA',
    EN_CURSO: 'EN_CURSO',
    REALIZADA: 'REALIZADA',
    ANULADA: 'ANULADA',
    CANCELADA: 'CANCELADA',
    RECEPCIONADA: 'RECEPCIONADA',
};

/**
 * Estados desde los que se puede cancelar: los que aún no han terminado.
 * Una REALIZADA ya ocurrió físicamente y el resto ya están cerradas.
 */
export const RECOGIDA_ESTADOS_CANCELABLES = [
    RECOGIDA_ESTADO.SOLICITADA,
    RECOGIDA_ESTADO.CONFIRMADA,
    RECOGIDA_ESTADO.ERROR,
    RECOGIDA_ESTADO.ASIGNADA,
    RECOGIDA_ESTADO.EN_CURSO,
];

/**
 * Estados que admiten sincronización bajo demanda con MSoft.
 * El resto devuelve 400 sin llegar a consultar MSoft.
 */
export const RECOGIDA_ESTADOS_SINCRONIZABLES = [
    RECOGIDA_ESTADO.CONFIRMADA,
    RECOGIDA_ESTADO.ASIGNADA,
    RECOGIDA_ESTADO.EN_CURSO,
];

export const RECOGIDA_ESTADO_LABELS = {
    SOLICITADA: 'Solicitada',
    CONFIRMADA: 'Confirmada',
    ERROR: 'Error',
    ASIGNADA: 'Asignada',
    EN_CURSO: 'En curso',
    REALIZADA: 'Realizada',
    ANULADA: 'Anulada',
    CANCELADA: 'Cancelada',
    RECEPCIONADA: 'Recepcionada',
};

export const RECOGIDA_ESTADO_CHIP = {
    SOLICITADA: 'warning',
    CONFIRMADA: 'success',
    ERROR: 'error',
    ASIGNADA: 'info',
    EN_CURSO: 'warning',
    REALIZADA: 'success',
    ANULADA: 'default',
    CANCELADA: 'default',
    RECEPCIONADA: 'success',
};

/**
 * De quién se recoge. No viaja a la API tal cual: el backend solo distingue por
 * `direccionLinea` (una línea de la ficha del cliente, o null si va suelta).
 * - CLIENTE: un cliente de la ficha, con una de sus direcciones
 * - CLIENTE_FINAL: no hay ficha, la dirección se escribe entera a mano
 */
export const TIPO_CLIENTE = {
    CLIENTE: 'CLIENTE',
    CLIENTE_FINAL: 'CLIENTE_FINAL',
};

export const TIPO_CLIENTE_LABELS = {
    CLIENTE: 'Cliente',
    CLIENTE_FINAL: 'Cliente final',
};

/**
 * Cliente genérico del ERP (ver api/docs/api/clientes.md). Las recogidas de cliente
 * final se registran contra él porque la API exige `clienteCodigo`, y el nombre real
 * del cliente final viaja en `clienteNombre` y en el nombre de contacto.
 */
export const CLIENTE_CONTADO_CODIGO = '43000001';
